export const VideosTranslations = {
    videosTranslations:{
        pageTitle: 'Videos',
        banner: {
            title: 'Music We Remember Ft. John Van Beek',
            description: 'Music We Remember is an exclusive, live performance concert series with music by John Van Beek',
            button: 'Start watching'
        },
    }
}